import { render, staticRenderFns } from "./keywordAssistant.vue?vue&type=template&id=c7ef6940&scoped=true"
import script from "./keywordAssistant.vue?vue&type=script&lang=js"
export * from "./keywordAssistant.vue?vue&type=script&lang=js"
import style0 from "./keywordAssistant.vue?vue&type=style&index=0&id=c7ef6940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ef6940",
  null
  
)

export default component.exports